export const messages = {
    "en": {
        "signInCommon": {
            "slogan": "The Leading\nMetals Information Provider",
            "bySigning": "By Creating an account, you agree to SMM’s",
            "privacyPolicy": "Privacy Policy",
            "and": "and",
            "TermsConditions": "Terms & Conditions",
            "copyright": "Copyright",
            "smmInformation": "SMM Information & Technology Co., Ltd. All rights reserved"
        },
        "login": {
            "title": "Welcome to SMM",
            "emailAddress": "Email Address",
            "emailAddress_error": "No account found with this email address",
            "requireEmail": "Please enter email address",
            "validEmail": "Please enter a valid email address",
            "password": "Password",
            "requirePassword": "Please enter password",
            "remember": "Remember me",
            "forgot": "Forgot password",
            "signIn": "Sign in",
            "signIn_toast": "The email or password you entered is incorrect",
            "signIn_toast_with_tries_left": "The email or password is incorrect, {count} tries left before lock.",
            "signIn_locked_toast": "Account locked for 1 hour. Please wait or click <link>\"Forgot password\"</link> to reset.",
            "simplePasswordMessage": "Your current password is too simple. Click <link>\"Forgot password\"</link> to change it for safety.",
            "or": "Or",
            "continue": "Continue with Google",
            "noAccount": "Don't have an account",
            "signUp": "Sign up"
        },
        "register": {
            "title": "Create Account",
            "requireEmail": "Please enter email address",
            "password": "Password",
            "requirePassword": "Please enter password",
            "send": "Send",
            "emailCode": "Email Code",
            "requireCode": "Please enter email code",
            "emailCode_error": "Email code is incorrect",
            "emailAddress": "Email Address",
            "resend": "Resend",
            "s": "s",
            "signIn": "Sign in",
            "continue": "Continue",
            "hasAccount": "Have an account?",
            "validEmail": "Please enter a valid email address",
            "alreadyAccount": "You already have an account",
            "registerSuccess": "Sign-up successful"
        },
        "forgot": {
            "title": "Forgot Password",
            "emailAddress": "Email Address",
            "requireEmail": "Please enter email address",
            "validEmail": "Please enter a valid email address",
            "email_toast": "No account found with this email address",
            "emailCode": "Email Code",
            "requireCode": "Please enter email code",
            "emailCode_error": "Email code is incorrect",
            "send": "Send",
            "resend": "Resend",
            "s": "s",
            "newPassword": "New Password",
            "requirePassword": "Please enter new password",
            "newPassword_error2": "Passwords do not match.",
            "confirmPassword": "Confirm New Password",
            "requireConfirmPassword": "Please confirm new password",
            "passwordsNotMatch": "Passwords do not match",
            "simplePasswordTip": "8-20 characters, no spaces, with at least 3 of: uppercase, lowercase, numbers, symbols.",
            "reset": "Reset",
            "resetSuccess": "Password reset successfully!",
            "changePassword": "Change Password",
            "oldPassword": "Old Password"
        },
        "passwordRules": {
            "length": "8-20 characters",
            "length_error": "Your password needs to be 8-20 characters long.",
            "composition": "At least 3 of: uppercase, lowercase, numbers, symbols. No spaces."
        }
    },
    "es": {
        "signInCommon": {
            "slogan": "El proveedor líder de información sobre metales",
            "bySigning": "Al crear una cuenta, usted acepta los",
            "privacyPolicy": "Política de privacidad",
            "and": "y",
            "TermsConditions": "Términos y Condiciones",
            "copyright": "Derechos de Autor",
            "smmInformation": "SMM Información y Tecnología, S.L. Derechos reservados"
        },
        "login": {
            "title": "Bienvenido a SMM",
            "emailAddress": "Dirección de correo electrónico",
            "requireEmail": "Por favor, ingrese la dirección de correo electrónico",
            "emailAddress_error": "No se encontró ninguna cuenta con esta dirección de correo electrónico",
            "validEmail": "Por favor, ingrese una dirección de correo electrónico válida",
            "password": "Contraseña",
            "requirePassword": "Por favor, ingrese la contraseña",
            "remember": "Recordarme",
            "forgot": "¿Olvidaste tu contraseña",
            "signIn": "Iniciar sesión",
            "signIn_toast": "El correo electrónico o la contraseña que ingresaste es incorrecto",
            "signIn_toast_with_tries_left": "El correo electrónico o la contraseña son incorrectos. Quedan {count} intentos antes del bloqueo.",
            "signIn_locked_toast": "La cuenta está bloqueada durante 1 hora. Espera o haz clic en <link>\"¿Olvidaste tu contraseña\"</link> para restablecerla.",
            "simplePasswordMessage": "Tu contraseña actual es demasiado simple. Haz clic en <link>\"¿Olvidaste tu contraseña?\"</link> para cambiarla por seguridad.",
            "or": "O",
            "continue": "Continuar con Google",
            "noAccount": "¿No tienes una cuenta?",
            "signUp": "Registrarse"
        },
        "register": {
            "title": "Crear Cuenta",
            "requireEmail": "Por favor, ingrese la dirección de correo electrónico",
            "password": "Contraseña",
            "requirePassword": "Por favor, ingrese la contraseña",
            "send": "Enviar",
            "emailCode": "Código de correo electrónico",
            "requireCode": "Por favor, ingrese el código de correo electrónico",
            "emailCode_error": "El código de correo electrónico es incorrecto",
            "emailAddress": "Dirección de correo electrónico",
            "resend": "Reenviar",
            "s": "s",
            "signIn": "Iniciar sesión",
            "continue": "Continuar",
            "hasAccount": "¿Ya tienes una cuenta?",
            "validEmail": "Por favor, ingrese una dirección de correo electrónico válida",
            "alreadyAccount": "Ya tienes una cuenta",
            "registerSuccess": "Registro exitoso"
        },
        "forgot": {
            "title": "Olvidé mi contraseña",
            "emailAddress": "Dirección de correo electrónico",
            "requireEmail": "Por favor, ingrese la dirección de correo electrónico",
            "validEmail": "Por favor, ingrese una dirección de correo electrónico válida",
            "email_toast": "No se encontró ninguna cuenta con esta dirección de correo electrónico",
            "emailCode": "Código de correo electrónico",
            "requireCode": "Por favor, ingrese el código de correo electrónico",
            "emailCode_error": "El código de correo electrónico es incorrecto",
            "send": "Enviar",
            "resend": "Reenviar",
            "s": "s",
            "newPassword": "Nueva Contraseña",
            "requirePassword": "Por favor, ingrese la contraseña",
            "newPassword_error2": "Las contraseñas no coinciden. ",
            "confirmPassword": "Confirmar nueva contraseña",
            "requireConfirmPassword": "Por favor, confirme la nueva contraseña",
            "passwordsNotMatch": "Las contraseñas no coinciden",
            "simplePasswordTip": "8-20 caracteres, sin espacios, con al menos 3 de: mayúsculas, minúsculas, números y símbolos.",
            "reset": "Restablecer",
            "resetSuccess": "¡Restablecimiento de contraseña exitoso!",
            "changePassword": "Cambiar contraseña",
            "oldPassword": "Contraseña Antigua"
        },
        "passwordRules": {
            "length": "8-20 caracteres",
            "length_error": "Tu contraseña debe tener entre 8 y 20 caracteres.",
            "composition": "Al menos 3 de: mayúsculas, minúsculas, números y símbolos. Sin espacios."
        }
    },
    "fr": {
        "signInCommon": {
            "slogan": "Le principal fournisseur d'informations sur les métaux",
            "bySigning": "En créant un compte, vous acceptez les conditions de SMM",
            "privacyPolicy": "Politique de confidentialité",
            "and": "et",
            "TermsConditions": "Conditions générales",
            "copyright": "Droits d'auteur",
            "smmInformation": "SMM Information & Technology Co., Ltd. Tous droits réservés"
        },
        "login": {
            "title": "Bienvenue sur SMM",
            "emailAddress": "Adresse e-mail",
            "requireEmail": "Veuillez saisir votre adresse e-mail",
            "emailAddress_error": "Aucun compte trouvé avec cette adresse e-mail",
            "validEmail": "Veuillez saisir une adresse e-mail valide",
            "password": "Mot de passe",
            "requirePassword": "Veuillez saisir le mot de passe",
            "remember": "Se souvenir de moi",
            "forgot": "Mot de passe oublié",
            "signIn": "Se connecter",
            "signIn_toast": "L'adresse e-mail ou le mot de passe saisi est incorrect",
            "signIn_toast_with_tries_left": "L'adresse e-mail ou le mot de passe est incorrect, il vous reste {count} tentatives avant le verrouillage.",
            "signIn_locked_toast": "Compte verrouillé pendant 1 heure. Veuillez patienter ou cliquer sur <link>\"Mot de passe oublié\"</link> pour le réinitialiser.",
            "simplePasswordMessage": "Votre mot de passe actuel est trop simple. Cliquez sur <link>\"Mot de passe oublié\"</link> pour le modifier par sécurité.",
            "or": "Ou",
            "continue": "Continuer avec Google",
            "noAccount": "Vous n'avez pas de compte",
            "signUp": "S'inscrire"
        },
        "register": {
            "title": "Créer un Compte",
            "requireEmail": "Veuillez saisir votre adresse e-mail",
            "password": "Mot de passe",
            "requirePassword": "Veuillez saisir le mot de passe",
            "send": "Envoyer",
            "emailCode": "Code e-mail",
            "requireCode": "Veuillez saisir le code de l'e-mail",
            "emailCode_error": "Le code e-mail est incorrect",
            "emailAddress": "Adresse e-mail",
            "resend": "Renvoyer",
            "s": "s",
            "signIn": "Se connecter",
            "continue": "Continuer",
            "hasAccount": "Vous avez un compte ?",
            "validEmail": "Veuillez saisir une adresse e-mail valide",
            "alreadyAccount": "Vous avez déjà un compte",
            "registerSuccess": "Inscription réussie"
        },
        "forgot": {
            "title": "Mot de passe oublié",
            "emailAddress": "Adresse e-mail",
            "requireEmail": "Veuillez saisir votre adresse e-mail",
            "validEmail": "Veuillez saisir une adresse e-mail valide",
            "email_toast": "Aucun compte trouvé avec cette adresse e-mail",
            "emailCode": "Code e-mail",
            "requireCode": "Veuillez saisir le code de l'e-mail",
            "emailCode_error": "Le code e-mail est incorrect",
            "send": "Envoyer",
            "resend": "Renvoyer",
            "s": "s",
            "newPassword": "Nouveau mot de passe",
            "requirePassword": "Veuillez saisir un nouveau mot de passe",
            "newPassword_error2": "Les mots de passe ne correspondent pas. ",
            "confirmPassword": "Confirmer le nouveau mot de passe",
            "requireConfirmPassword": "Veuillez confirmer le nouveau mot de passe",
            "passwordsNotMatch": "Les mots de passe ne correspondent pas",
            "simplePasswordTip": "8-20 caractères, sans espaces, avec au moins 3 parmi : majuscules, minuscules, chiffres, symboles.",
            "reset": "Réinitialiser",
            "resetSuccess": "Réinitialisation du mot de passe réussie !",
            "changePassword": "Changer le mot de passe",
            "oldPassword": "Ancien Mot de Passe"
        },
        "passwordRules": {
            "length": "8-20 caractères",
            "length_error": "Votre mot de passe doit contenir entre 8 et 20 caractères.",
            "composition": "Au moins 3 parmi : majuscules, minuscules, chiffres, symboles. Sans espaces."
        }
    },
    "id": {
        "signInCommon": {
            "slogan": "Penyedia Informasi Logam Terkemuka",
            "bySigning": "Dengan Membuat akun, Anda menyetujui SMM",
            "privacyPolicy": "Kebijakan Privasi",
            "and": "dan",
            "TermsConditions": "Syarat & Ketentuan",
            "copyright": "Hak Cipta",
            "smmInformation": "PT. Informasi & Teknologi SMMSeluruh hak cipta dilindungi undang-undang"
        },
        "login": {
            "title": "Selamat datang di SMM",
            "emailAddress": "Alamat Email",
            "requireEmail": "Masukkan alamat email",
            "emailAddress_error": "Tidak ada akun yang ditemukan dengan alamat email ini",
            "validEmail": "Masukkan alamat email yang valid",
            "password": "Kata Sandi",
            "requirePassword": "Masukkan kata sandi",
            "remember": "Ingat saya",
            "forgot": "Lupa kata sandi",
            "signIn": "Masuk",
            "signIn_toast": "Email atau kata sandi yang Anda masukkan salah",
            "signIn_toast_with_tries_left": "Email atau kata sandi salah, tersisa {count} percobaan sebelum akun dikunci.",
            "signIn_locked_toast": "Akun dikunci selama 1 jam. Silakan tunggu atau klik <link>\"Lupa kata sandi\"</link> untuk mereset.",
            "simplePasswordMessage": "Kata sandi Anda saat ini terlalu sederhana. Klik <link>\"Lupa kata sandi\"</link> untuk mengubahnya demi keamanan.",
            "or": "Atau",
            "continue": "Lanjutkan dengan Google",
            "noAccount": "Belum punya akun",
            "signUp": "Daftar"
        },
        "register": {
            "title": "Buat Akun",
            "requireEmail": "Masukkan alamat email",
            "password": "Kata Sandi",
            "requirePassword": "Masukkan kata sandi",
            "send": "Kirim",
            "emailCode": "Kode Email",
            "requireCode": "Masukkan kode email",
            "emailCode_error": "Kode email salah",
            "emailAddress": "Alamat Email",
            "resend": "Kirim Ulang",
            "s": "s",
            "signIn": "Masuk",
            "continue": "Lanjutkan",
            "hasAccount": "Sudah punya akun?",
            "validEmail": "Masukkan alamat email yang valid",
            "alreadyAccount": "Anda sudah memiliki akun",
            "registerSuccess": "Pendaftaran berhasil"
        },
        "forgot": {
            "title": "Lupa Kata Sandi",
            "emailAddress": "Alamat Email",
            "requireEmail": "Masukkan alamat email",
            "validEmail": "Masukkan alamat email yang valid",
            "email_toast": "Tidak ada akun yang ditemukan dengan alamat email ini",
            "emailCode": "Kode Email",
            "requireCode": "Masukkan kode email",
            "emailCode_error": "Kode email salah",
            "send": "Kirim",
            "resend": "Kirim Ulang",
            "s": "s",
            "newPassword": "Kata Sandi Baru",
            "requirePassword": "Masukkan kata sandi baru",
            "newPassword_error2": "Kata sandi tidak cocok. ",
            "confirmPassword": "Konfirmasi Kata Sandi Baru",
            "requireConfirmPassword": "Harap konfirmasi kata sandi baru",
            "passwordsNotMatch": "Kata sandi tidak cocok",
            "simplePasswordTip": "8-20 karakter, tanpa spasi, dengan setidaknya 3 dari: huruf besar, huruf kecil, angka, simbol.",
            "reset": "Atur Ulang",
            "resetSuccess": "Setel ulang kata sandi berhasil!",
            "changePassword": "Ubah Kata Sandi",
            "oldPassword": "Kata Sandi Lama"
        },
        "passwordRules": {
            "length": "8-20 karakter",
            "length_error": "Kata sandi Anda harus terdiri dari 8-20 karakter.",
            "composition": "Setidaknya 3 dari: huruf besar, huruf kecil, angka, simbol. Tanpa spasi."
        }
    },
    "pt": {
        "signInCommon": {
            "slogan": "O principal provedor de informações sobre metais",
            "bySigning": "Ao criar uma conta, você concorda com os",
            "privacyPolicy": "Política de Privacidade",
            "and": "e",
            "TermsConditions": "Termos e Condições",
            "copyright": "Direitos Autorais",
            "smmInformation": "SMM Informação & Tecnologia Ltda. Todos os direitos reservados"
        },
        "login": {
            "title": "Bem-vindo ao SMM",
            "emailAddress": "Endereço de E-mail",
            "requireEmail": "Por favor, insira o endereço de e-mail",
            "emailAddress_error": "Nenhuma conta encontrada com este endereço de e-mail",
            "validEmail": "Por favor, insira um endereço de e-mail válido",
            "password": "Senha",
            "requirePassword": "Por favor, insira a senha",
            "remember": "Lembrar-me",
            "forgot": "Esqueceu a palavra-passe",
            "signIn": "Entrar",
            "signIn_toast": "O e-mail ou a palavra-passe que introduziu estão incorretos",
            "signIn_toast_with_tries_left": "O e-mail ou a palavra-passe estão incorretos, restam {count} tentativas antes do bloqueio.",
            "signIn_locked_toast": "Conta bloqueada durante 1 hora. Aguarde ou clique em <link>\"Esqueceu a palavra-passe\"</link> para redefinir.",
            "simplePasswordMessage": "A sua senha atual é demasiado simples. Clique em <link>\"Esqueceu a senha\"</link> para alterá-la por segurança.",
            "or": "Ou",
            "continue": "Continuar com o Google",
            "noAccount": "Não tem uma conta",
            "signUp": "Registar"
        },
        "register": {
            "title": "Criar Conta",
            "requireEmail": "Por favor, insira o endereço de e-mail",
            "password": "Senha",
            "requirePassword": "Por favor, insira a senha",
            "send": "Enviar",
            "emailCode": "Código por E-mail",
            "requireCode": "Por favor, insira o código de e-mail",
            "emailCode_error": "Código de e-mail incorreto",
            "emailAddress": "Endereço de E-mail",
            "resend": "Reenviar",
            "s": "s",
            "signIn": "Entrar",
            "continue": "Continuar",
            "hasAccount": "Já tem uma conta?",
            "validEmail": "Por favor, insira um endereço de e-mail válido",
            "alreadyAccount": "Você já tem uma conta",
            "registerSuccess": "Cadastro realizado com sucesso"
        },
        "forgot": {
            "title": "Esqueceu a Senha",
            "emailAddress": "Endereço de E-mail",
            "requireEmail": "Por favor, insira o endereço de e-mail",
            "validEmail": "Por favor, insira um endereço de e-mail válido",
            "email_toast": "Nenhuma conta encontrada com este endereço de e-mail",
            "emailCode": "Código por E-mail",
            "requireCode": "Por favor, insira o código de e-mail",
            "emailCode_error": "Código de e-mail incorreto",
            "send": "Enviar",
            "resend": "Reenviar",
            "s": "s",
            "newPassword": "Nova Palavra-passe",
            "requirePassword": "Por favor, insira a nova senha",
            "newPassword_error2": "As senhas não coincidem. ",
            "confirmPassword": "Confirmar Nova Senha",
            "requireConfirmPassword": "Por favor, confirme a nova senha",
            "passwordsNotMatch": "As palavras-passe não coincidem",
            "simplePasswordTip": "8-20 caracteres, sem espaços, com pelo menos 3 de: maiúsculas, minúsculas, números, símbolos.",
            "reset": "Redefinir",
            "resetSuccess": "Redefinição de senha bem-sucedida!",
            "changePassword": "Alterar Senha",
            "oldPassword": "Senha Antiga"
        },
        "passwordRules": {
            "length": "8-20 caracteres",
            "length_error": "Sua senha deve ter entre 8 e 20 caracteres.",
            "composition": "Pelo menos 3 destes: maiúsculas, minúsculas, números e símbolos. Sem espaços."
        }
    },
    "ru": {
        "signInCommon": {
            "slogan": "Ведущий поставщик информации о металлах",
            "bySigning": "Создавая аккаунт, вы соглашаетесь с условиями SMM",
            "privacyPolicy": "Политика конфиденциальности",
            "and": "и",
            "TermsConditions": "Условия и положения",
            "copyright": "Авторское право",
            "smmInformation": "Информационные и технологические системы ОООВсе права защищены"
        },
        "login": {
            "title": "Добро пожаловать в SMM",
            "emailAddress": "Адрес электронной почты",
            "requireEmail": "Пожалуйста, введите адрес электронной почты",
            "emailAddress_error": "Аккаунт с таким адресом электронной почты не найден",
            "validEmail": "Пожалуйста, введите действительный адрес электронной почты",
            "password": "Пароль",
            "requirePassword": "Введите пароль",
            "remember": "Запомнить меня",
            "forgot": "Забыли пароль",
            "signIn": "Войти",
            "signIn_toast": "Введённый email или пароль неверны",
            "signIn_toast_with_tries_left": "Email или пароль неверны, осталось {count} попыток до блокировки.",
            "signIn_locked_toast": "Аккаунт заблокирован на 1 час. Подождите или нажмите <link>\"Забыли пароль\"</link>, чтобы сбросить пароль.",
            "simplePasswordMessage": "Ваш текущий пароль слишком простой. Нажмите <link>\"Забыли пароль\"</link>, чтобы изменить его для безопасности.",
            "or": "Или",
            "continue": "Продолжить через Google",
            "noAccount": "Нет аккаунта",
            "signUp": "Зарегистрироваться"
        },
        "register": {
            "title": "Создать аккаунт",
            "requireEmail": "Пожалуйста, введите адрес электронной почты",
            "password": "Пароль",
            "requirePassword": "Введите пароль",
            "send": "Отправить",
            "emailCode": "Код по электронной почте",
            "requireCode": "Введите код из email",
            "emailCode_error": "Неверный код из электронной почты",
            "emailAddress": "Адрес электронной почты",
            "resend": "Повторная отправка",
            "s": "s",
            "signIn": "Войти",
            "continue": "Продолжить",
            "hasAccount": "Есть аккаунт?",
            "validEmail": "Пожалуйста, введите действительный адрес электронной почты",
            "alreadyAccount": "У вас уже есть аккаунт",
            "registerSuccess": "Регистрация успешна"
        },
        "forgot": {
            "title": "Забыли пароль",
            "emailAddress": "Адрес электронной почты",
            "requireEmail": "Пожалуйста, введите адрес электронной почты",
            "validEmail": "Пожалуйста, введите действительный адрес электронной почты",
            "email_toast": "Аккаунт с таким адресом электронной почты не найден",
            "emailCode": "Код по электронной почте",
            "requireCode": "Введите код из email",
            "emailCode_error": "Неверный код из электронной почты",
            "send": "Отправить",
            "resend": "Повторная отправка",
            "s": "s",
            "newPassword": "Новый пароль",
            "requirePassword": "Введите новый пароль",
            "newPassword_error2": "Пароли не совпадают. ",
            "confirmPassword": "Подтвердите новый пароль",
            "requireConfirmPassword": "Пожалуйста, подтвердите новый пароль",
            "passwordsNotMatch": "Пароли не совпадают",
            "simplePasswordTip": "8-20 символов, без пробелов, как минимум 3 типа из: заглавные буквы, строчные буквы, цифры, символы.",
            "reset": "Сброс",
            "resetSuccess": "Пароль успешно сброшен！",
            "changePassword": "Изменить пароль",
            "oldPassword": "Старый пароль"
        },
        "passwordRules": {
            "length": "8-20 символов",
            "length_error": "Ваш пароль должен содержать от 8 до 20 символов.",
            "composition": "Как минимум 3 из: заглавные буквы, строчные буквы, цифры, символы. Без пробелов."
        }
    },
    "th": {
        "signInCommon": {
            "slogan": "ผู้นำผู้ให้ข้อมูลด้านโลหะ",
            "bySigning": "โดยการสร้างบัญชี คุณยอมรับตาม",
            "privacyPolicy": "นโยบายความเป็นส่วนตัว",
            "and": "และ",
            "TermsConditions": "ข้อกำหนดและเงื่อนไข",
            "copyright": "ลิขสิทธิ์",
            "smmInformation": "บริษัท เอสเอ็มเอ็ม อินฟอร์เมชั่น แอนด์ เทคโนโลยี จำกัดAll rights reserved"
        },
        "login": {
            "title": "ยินดีต้อนรับสู่ SMM",
            "emailAddress": "อีเมล",
            "requireEmail": "กรุณากรอกที่อยู่อีเมล",
            "emailAddress_error": "ไม่พบบัญชีที่ใช้อีเมลนี้",
            "validEmail": "กรุณากรอกอีเมลให้ถูกต้อง",
            "password": "รหัสผ่าน",
            "requirePassword": "กรุณาใส่รหัสผ่าน",
            "remember": "จำฉันไว้",
            "forgot": "ลืมรหัสผ่าน",
            "signIn": "เข้าสู่ระบบ",
            "signIn_toast": "อีเมลหรือรหัสผ่านที่คุณป้อนไม่ถูกต้อง",
            "signIn_toast_with_tries_left": "อีเมลหรือรหัสผ่านไม่ถูกต้อง เหลืออีก {count} ครั้งก่อนบัญชีถูกล็อก",
            "signIn_locked_toast": "บัญชีถูกล็อกเป็นเวลา 1 ชั่วโมง โปรดรอหรือคลิก <link>\"ลืมรหัสผ่าน\"</link> เพื่อรีเซ็ต",
            "simplePasswordMessage": "รหัสผ่านปัจจุบันของคุณง่ายเกินไป คลิก <link>\"ลืมรหัสผ่าน\"</link> เพื่อเปลี่ยนเพื่อความปลอดภัย",
            "or": "หรือ",
            "continue": "ดำเนินการต่อด้วย Google",
            "noAccount": "ยังไม่มีบัญชี",
            "signUp": "สมัครสมาชิก"
        },
        "register": {
            "title": "สร้างบัญชี",
            "requireEmail": "กรุณากรอกที่อยู่อีเมล",
            "password": "รหัสผ่าน",
            "requirePassword": "กรุณาใส่รหัสผ่าน",
            "send": "ส่ง",
            "emailCode": "รหัสอีเมล",
            "requireCode": "กรุณาใส่รหัสอีเมล",
            "emailCode_error": "รหัสอีเมลไม่ถูกต้อง",
            "emailAddress": "อีเมลแอดเดรส",
            "resend": "ส่งซ้ำ",
            "s": "s",
            "signIn": "เข้าสู่ระบบ",
            "continue": "ดำเนินการต่อ",
            "hasAccount": "มีบัญชีอยู่แล้ว?",
            "validEmail": "กรุณากรอกอีเมลให้ถูกต้อง",
            "alreadyAccount": "คุณมีบัญชีอยู่แล้ว",
            "registerSuccess": "สมัครสมาชิกสำเร็จ"
        },
        "forgot": {
            "title": "ลืมรหัสผ่าน",
            "emailAddress": "อีเมลแอดเดรส",
            "requireEmail": "กรุณากรอกที่อยู่อีเมล",
            "validEmail": "กรุณากรอกอีเมลให้ถูกต้อง",
            "email_toast": "ไม่พบบัญชีที่ใช้อีเมลนี้",
            "emailCode": "รหัสอีเมล",
            "requireCode": "กรุณาใส่รหัสอีเมล",
            "emailCode_error": "รหัสอีเมลไม่ถูกต้อง",
            "send": "ส่ง",
            "resend": "ส่งซ้ำ",
            "s": "s",
            "newPassword": "รหัสผ่านใหม่",
            "requirePassword": "กรุณาใส่รหัสผ่านใหม่",
            "newPassword_error2": "รหัสผ่านไม่ตรงกัน",
            "confirmPassword": "ยืนยันรหัสผ่านใหม่",
            "requireConfirmPassword": "กรุณายืนยันรหัสผ่านใหม่",
            "passwordsNotMatch": "รหัสผ่านไม่ตรงกัน",
            "simplePasswordTip": "8-20 ตัวอักษร, ห้ามเว้นวรรค, และต้องมีอย่างน้อย 3 ประเภทจาก: ตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข สัญลักษณ์",
            "reset": "รีเซ็ต",
            "resetSuccess": "รีเซ็ตรหัสผ่านสำเร็จ",
            "changePassword": "เปลี่ยนรหัสผ่าน",
            "oldPassword": "รหัสผ่านเก่า"
        },
        "passwordRules": {
            "length": "8-20 ตัวอักษร",
            "length_error": "รหัสผ่านของคุณต้องมีความยาว 8-20 ตัวอักษร",
            "composition": "ต้องมีอย่างน้อย 3 อย่างจาก: ตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข สัญลักษณ์ และห้ามมีช่องว่าง"
        }
    },
    "vn": {
        "signInCommon": {
            "slogan": "Nhà cung cấp thông tin kim loại hàng đầu",
            "bySigning": "Bằng cách Tạo tài khoản, bạn đồng  ý với Điều khoản của SMM",
            "privacyPolicy": "Chính sách Bảo mật",
            "and": "và",
            "TermsConditions": "Điều khoản & Điều kiện",
            "copyright": "Bản quyền",
            "smmInformation": "Công ty TNHH Công nghệ & Thông tin SMMTất cả các quyền được bảo lưu"
        },
        "login": {
            "title": "Chào mừng đến với SMM",
            "emailAddress": "Địa chỉ Email",
            "requireEmail": "Vui lòng nhập địa chỉ email",
            "emailAddress_error": "Không tìm thấy tài khoản nào với địa chỉ email này",
            "validEmail": "Vui lòng nhập địa chỉ email hợp lệ",
            "password": "Mật khẩu",
            "requirePassword": "Vui lòng nhập mật khẩu",
            "remember": "Ghi nhớ tôi",
            "forgot": "Quên mật khẩu",
            "signIn": "Đăng nhập",
            "signIn_toast": "Email hoặc mật khẩu bạn nhập không chính xác",
            "signIn_toast_with_tries_left": "Email hoặc mật khẩu không chính xác, còn {count} lần thử trước khi bị khóa.",
            "signIn_locked_toast": "Tài khoản bị khóa trong 1 giờ. Vui lòng chờ hoặc nhấp vào <link>\"Quên mật khẩu\"</link> để đặt lại.",
            "simplePasswordMessage": "Mật khẩu hiện tại của bạn quá đơn giản. Nhấp vào <link>\"Quên mật khẩu\"</link> để thay đổi nhằm đảm bảo an toàn.",
            "or": "Hoặc",
            "continue": "Tiếp tục với Google",
            "noAccount": "Chưa có tài khoản",
            "signUp": "Đăng ký"
        },
        "register": {
            "title": "Tạo Tài Khoản",
            "requireEmail": "Vui lòng nhập địa chỉ email",
            "password": "Mật khẩu",
            "requirePassword": "Vui lòng nhập mật khẩu",
            "send": "Gửi",
            "emailCode": "Mã email",
            "requireCode": "Vui lòng nhập mã email",
            "emailCode_error": "Mã email không chính xác",
            "emailAddress": "Địa chỉ Email",
            "resend": "Gửi lại",
            "s": "s",
            "signIn": "Đăng nhập",
            "continue": "Tiếp tục",
            "hasAccount": "Đã có tài khoản?",
            "validEmail": "Vui lòng nhập địa chỉ email hợp lệ",
            "alreadyAccount": "Bạn đã có tài khoản",
            "registerSuccess": "Đăng ký thành công"
        },
        "forgot": {
            "title": "Quên Mật khẩu",
            "emailAddress": "Địa chỉ Email",
            "requireEmail": "Vui lòng nhập địa chỉ email",
            "validEmail": "Vui lòng nhập địa chỉ email hợp lệ",
            "email_toast": "Không tìm thấy tài khoản nào với địa chỉ email này",
            "emailCode": "Mã email",
            "requireCode": "Vui lòng nhập mã email",
            "emailCode_error": "Mã email không chính xác",
            "send": "Gửi",
            "resend": "Gửi lại",
            "s": "s",
            "newPassword": "Mật khẩu mới",
            "requirePassword": "Vui lòng nhập mật khẩu mới",
            "newPassword_error2": "Mật khẩu không khớp. ",
            "confirmPassword": "Xác nhận mật khẩu mới",
            "requireConfirmPassword": "Vui lòng xác nhận mật khẩu mới",
            "passwordsNotMatch": "Mật khẩu không khớp",
            "simplePasswordTip": "8-20 ký tự, không có khoảng trắng, với ít nhất 3 trong các loại: chữ hoa, chữ thường, số, ký tự đặc biệt.",
            "reset": "Đặt lại",
            "resetSuccess": "Đặt lại mật khẩu thành công!",
            "changePassword": "Đổi mật khẩu",
            "oldPassword": "Mật khẩu cũ"
        },
        "passwordRules": {
            "length": "8-20 ký tự",
            "length_error": "Mật khẩu của bạn phải có từ 8 đến 20 ký tự.",
            "composition": "Ít nhất 3 trong các loại sau: chữ hoa, chữ thường, số, ký tự đặc biệt. Không có khoảng trắng."
        }
    }
};
//# sourceMappingURL=messages.generated.js.map